// extracted by mini-css-extract-plugin
module.exports = {"categoryBox":"AllCategories_categoryBox__-zJvc"};